import {
  authServer
} from '../globalVars';
import { store } from "../_store";

// eslint-disable-next-line no-undef
const axios = require('axios').default;

function createAxios() {
  // return authorization header with jwt token
  const user = JSON.parse(localStorage.getItem('user'));
  const headers = {};
  if (user && user.token) {
    headers.Authorization = `Bearer ${user.token}`;
  }
  const instance = axios.create({
    baseURL: authServer,
    headers
  });

  instance.interceptors.response.use((response) => Promise.resolve(response.data),
    (error) => {
      if ([403].includes(error.response.data.error.status)) {
        store.dispatch("user/clearSession");
        // eslint-disable-next-line no-restricted-globals
        location.reload(true);
      }
      return Promise.reject(error.response.data);
    });

  return instance;
}

export default createAxios;
